import React, { memo, useContext, useEffect, useRef, useState } from "react";
import {
  EachNumber,
  LessOrMoreBtn,
  PreviousNumbers,
  LessContainer,
  LessContainerNumbers,
  MoreContainer,
} from "./PreviousRoundsStyle";
import { AppContext, ValueContext } from "../../../context/createContext";

const PreviousRounds = () => {
  const { train } = useContext(AppContext);

  const {
    roundupdate: { value, state },
  } = useContext(ValueContext);
  
  const [lessOrMore, setLessOrMore] = useState<boolean>(false);
  const [shouldAnimate, setSouldAnimate] = useState<boolean>(false);
  const [previousRounds, setPreviousRounds] = useState<any[]>([]);

  const moreRef = useRef<any>(null);

  useEffect(() => {
    setPreviousRounds(train);
  }, [train]);

  const changeLessOrMore = (e: any) => {
    if (
      e.target.className.includes !== undefined &&
      e.target.className.includes("less-or-more-button")
    ) {
      setLessOrMore((prevBoolean) => !prevBoolean);
      setSouldAnimate(false);
    } else {
      setLessOrMore(false);
    }
  };

  useEffect(() => {
    if (state === 3) {
      const newArray = [value, ...previousRounds];
      if (newArray.length > 30) {
        newArray.pop();
      }
      setPreviousRounds(newArray);
      if (!shouldAnimate) {
        setSouldAnimate(true);
      }
    } else {
      setSouldAnimate(false);
    }
  }, [state]);

  useEffect(() => {
    window.addEventListener("click", changeLessOrMore);

    return () => {
      window.removeEventListener("click", changeLessOrMore);
    };
  }, [lessOrMore]);

  const moreArray = [...previousRounds].reverse();

  return (
    <PreviousNumbers>
      {lessOrMore ? (
        <MoreContainer ref={moreRef}>
          <LessOrMoreBtn
            lessOrMore={lessOrMore}
            className="less-or-more-button"
          >
            {lessOrMore ? "less" : "more"}
          </LessOrMoreBtn>
          {moreArray.map((number, i) => (
            <EachNumber number={+number} key={i}>
              {number.toString()}x
            </EachNumber>
          ))}
        </MoreContainer>
      ) : (
        <LessContainer>
          <LessContainerNumbers>
            {previousRounds.map((number, i) => (
              <EachNumber
                number={+number}
                key={i}
                shouldAnimate={shouldAnimate}
              >
                {number.toString()}x
              </EachNumber>
            ))}
          </LessContainerNumbers>
          <LessOrMoreBtn
            lessOrMore={lessOrMore}
            className="less-or-more-button"
          >
            {lessOrMore ? "less" : "more"}
          </LessOrMoreBtn>
        </LessContainer>
      )}
    </PreviousNumbers>
  );
};

export default memo(PreviousRounds);
